import { DefaultState, RoomStatuses } from 'store/types';

export const ROOM_DETAILS_REQUEST = 'ROOM_DETAILS_REQUEST';
export const ROOM_DETAILS_SUCCESS = 'ROOM_DETAILS_SUCCESS';
export const ROOM_DETAILS_FAILURE = 'ROOM_DETAILS_FAILURE';

export interface RoomDetails {
  id: string;
  lodgingOptionId: string;
  reservationId: string;
  lodgingOptionName: string;
  lodgingOptionLocation: string;
  lodgingOptionStatus?: string;
  dates: string;
  occupancy: number;
  bookingUserFriendlyId: string | undefined;
  percentageBooked: string;
  reservationProviderId: string;
  reservationProviderName: string;
  providerSendNotification: boolean;
  clcRequestNumber: string;
  roomType: string;
  totalRate: string;
  personRate: string;
  status: RoomStatuses;
  fromDate: string;
  toDate: string;
};

export type RoomDetailsState = DefaultState & {
  contents?: RoomDetails;
};

interface RoomDetailsRequest {
  type: typeof ROOM_DETAILS_REQUEST;
};

interface RoomDetailsSuccess {
  type: typeof ROOM_DETAILS_SUCCESS,
  contents: RoomDetails;
}

interface RoomDetailsFailure {
  type: typeof ROOM_DETAILS_FAILURE;
}

export type RoomFormDataActionTypes = RoomDetailsRequest | RoomDetailsSuccess | RoomDetailsFailure;